export const supportedUserLanguages = ["en", "fi", "sv"] as const

export type UserLanguage = typeof supportedUserLanguages[number]

export const defaultUserLanguage: UserLanguage = "en"

export const isUserLanguage = (maybeLang: string): maybeLang is UserLanguage =>
  ((supportedUserLanguages as unknown) as string[]).includes(maybeLang)

export const resolveUserLanguageWDefault = (
  maybeLang: string,
): UserLanguage => {
  if (isUserLanguage(maybeLang)) {
    return maybeLang
  }

  return defaultUserLanguage
}
